module.exports = __webpack_public_path__ + "static/media/ft-marketing.47cbf24b.svg";